<template>
    <div style="margin-left: 10px">
        <h1 style="font-size: 24px"><b>Zendesk Language Mapping</b></h1>
        <p>Here you can replace existing Zendesk language mappings, or add new mappings.</p>
        <div class="content">
            <div class="flex header-container">
                <img style="height: 20px; width: 20px; margin-right: 5px" src="/images/connector-logos/zendesk.png">
                <h2 style="font-size: 15px">Zendesk Language Mappings</h2>
            </div>
            <div class="inner-zendesk-picker">
                <label><b>Select the account for which you want to add or change mappings.</b></label>
                <v-select
                    :options="this.accountList"
                    v-model="this.account"
                    :clearable="false"
                    class="v-select-styling"
                    label="name"
                    placeholder="Type name or space to find accounts"
                    @search="onAccountSearch"
                    @input="accountSelected"
                >
                    <template slot="no-options">
                        Type name or space to find accounts
                    </template>
                </v-select>
                <div v-if="this.account && !this.mappedLanguages.length" style="margin: 20px 0px">No mappings found. Add
                    a mapping by clicking on
                    the button below.
                </div>
                <div class="mapping-content" v-if="this.mappedLanguages.length">
                    <div><h4>Language Mappings</h4></div>
                    <table class="mapping-table">
                        <thead>
                        <th >
                            <div class="mapping-table-header">
                                <div>Zendesk language
                                    <eye-icon
                                        title="Show languages"
                                        @click="openZendeskList"
                                        fillColor="#cccccc"
                                        class="reference-action-icon cursor-pointer"
                                        :size="12"/>
                                </div>
                            </div>
                        </th>
                        <th></th>
                        <th>
                            <div class="mapping-table-header">
                                <div>My Acclaro language</div>
                                <div>
                                    <eye-icon
                                        title="Show languages"
                                        @click="openLanguages"
                                        fillColor="#cccccc"
                                        class="reference-action-icon cursor-pointer"
                                        :size="12"/>
                                </div>
                            </div>
                        </th>
                        </thead>
                        <tbody>
                        <tr v-for="mapping in this.mappedLanguages" @key="mapping.from">
                            <td class="border_bottom">
                                <input placeholder="Type language code..." class="language-input" v-model="mapping.from"/>
                            </td>
                            <td class="border_bottom">
                                <i class="acclaro-icon icon-tree-arrow-right"></i>
                            </td>
                            <td class="border_bottom">
                                <input placeholder="Type language code..." class="language-input" v-model="mapping.to"/>
                            </td>
                            <td class="border_bottom">
                                <span class="clickable" @click.prevent="deleteMapping(mapping.from)">
                                    <span class="acclaro-icon ai-close"></span> </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!--                <div class="map-content" v-if="this.account">-->
                <!--                    <div class="mapping-list flex">-->
                <!--                        <ul>-->
                <!--                            <li v-for="mapping in this.mappedLanguages" @key="mapping.from" class="list-item">-->
                <!--                                <input class="language-input" v-model="mapping.from"/><i class="acclaro-icon icon-tree-arrow-right"></i><input v-model="mapping.to"/>-->
                <!--                                <span class="clickable" @click.prevent="deleteMapping(mapping.from)">-->
                <!--                                    <span class="acclaro-icon ai-close"></span>-->
                <!--                                </span>-->
                <!--                            </li>-->
                <!--                        </ul>-->
                <!--                    </div>-->
                <div class="flex map-content-footer" v-if="this.account">
                    <button class="bbutton" @click.prevent="addMapping">Add Mapping</button>
                    <button class="bbutton" @click.prevent="saveMappings">Save Mappings</button>
                </div>
                <!--                </div>-->
            </div>
        </div>
    </div>

</template>

<script>
import axios from "axios";
import {debounce} from "lodash";
import {
    EyeIcon,
} from "../icons.js";

export default {
    name: "AdminZendeskLanguageMapSettings",
    components: {
        EyeIcon,
    },
    data: function () {
        return {
            accountList: [],
            account: undefined,
            mappedLanguages: []
        }
    },
    methods: {
        onAccountSearch(search, loading) {
            if (search.length) {
                this.searchAccounts(loading, search, this);
            }
        },
        searchAccounts: debounce((loading, search, vm) => {
            axios.get(
                `/accounts/all?search=${escape(search)}&only_active=0`
            ).then(res => {
                vm.accountList = res.data ?? []
            });
        }, 500),
        accountSelected(value) {
            this.account = value;
            axios.get(
                `/admin/connector/zendesk/language-map/${escape(this.account.id)}`
            ).then(({data}) => {
                console.log(data)
                this.mappedLanguages = data.data ?? []
            });
        },
        addMapping() {
            this.mappedLanguages.unshift({
                from: '',
                to: ''
            })

        },
        saveMappings() {
            console.log(this.mappedLanguages)
            axios.post(
                `/admin/connector/zendesk/language-map`, {
                    'account_id': this.account.id,
                    'mappings': this.mappedLanguages
                }
            ).then((res, vm) => {
                alert('Mappings updated.')
            });
        },
        deleteMapping(source) {
            this.mappedLanguages = this.mappedLanguages.filter(object => {
                return object.from !== source;
            })
        },
        openLanguages() {
            window.open(window.location.origin + '/admin/languages', '_blank')
        },
        openZendeskList() {
            window.open("https://support.zendesk.com/hc/en-us/articles/4408821324826#h_01EYXD488X3XK23TG9VPG0W6KS", '_blank')
        }
    }
}
</script>

<style scoped>
.content {
    width: 600px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
}

.mapping-content {
    padding-bottom: 10px;
}

.header-container {
    align-items: center;
    background: #FAFAFA;
    padding: 5px 15px;
    border-bottom: 1px solid #EEEEEE;
}

.inner-zendesk-picker {
    padding: 10px 20px;
}

/*.map-content {*/
/*    border: 1px solid gray;*/
/*    border-radius: 5px;*/
/*    padding: 10px;*/
/*    margin: 10px 0;*/
/*    min-height: 500px;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*}*/

/*.mapping-list {*/
/*    width: 100%;*/
/*    max-height: 450px;*/
/*    min-height: 450px;*/
/*    overflow-x: scroll;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*}*/

.map-content-footer {
    align-self: flex-end;
    width: 100%;
    justify-content: flex-end;
    margin-top: 10px;
}

.mapping-table-header {
    display: flex;
    padding: 10px 0;
    font-size: 12px;
    width: 100%;
    justify-content: center;

}

.mapping-table {
    border: 1px solid #EEEEEE;
    padding: 20px 11px;
    border-radius: 10px;
}

/*.list-item {*/
/*    margin: 10px 0;*/
/*}*/

.language-input {
    border: 1px solid rgba(60,60,60,.26);
    border-radius: 5px;
    padding: 10px;
}

.border_bottom {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 10px;
}

table {
    border-collapse: collapse;
}

</style>
